
export default function getCountriesList() {
    // const requestOptions = {
    //     method: 'GET',
    //     headers: { 'Content-Type': 'application/json' },
    // body: JSON.stringify(router.query)
    // };
    return fetch('/shared/api/getCountryList').then((response) => response.json())
}